import EditProfile from '../../app/features/EditProfile';
const EditProfilePage = () => <EditProfile />

export default EditProfilePage